import { render, staticRenderFns } from "./Gift_TouSu2.vue?vue&type=template&id=b2f852c4&scoped=true"
import script from "./Gift_TouSu2.vue?vue&type=script&lang=js"
export * from "./Gift_TouSu2.vue?vue&type=script&lang=js"
import style0 from "./Gift_TouSu2.vue?vue&type=style&index=0&id=b2f852c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f852c4",
  null
  
)

export default component.exports